import React, { Component } from "react";
import { Route } from "react-router-dom";
import "./index.css";
import JourneyMain from "./pages/journey-main";
import JourneyBlocked from "./components/JourneyBlocked";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: "",
    };
  }
  render() {
    return (
      <>
        {/* Travel QR is the only live journey -- see pages/journey-main. */}
        <Route exact path="/" component={JourneyMain} />
        {/* Every other journey entry point below is disabled on purpose. */}
        <Route exact path="/basic-details" component={JourneyBlocked} />
        <Route exact path="/patient-details" component={JourneyBlocked} />
        <Route exact path="/fee-details" component={JourneyBlocked} />
        <Route exact path="/pre-pan" component={JourneyBlocked} />
        <Route exact path="/qr-success-page" component={JourneyBlocked} />
        <Route exact path="/miscall-landing" component={JourneyBlocked} />
        <Route exact path="/miscall-error-page" component={JourneyBlocked} />
        <Route exact path="/student-details" component={JourneyBlocked} />
        <Route
          exact
          path="/school-fee-offer-journey"
          component={JourneyBlocked}
        />
        <Route exact path="/parent-details" component={JourneyBlocked} />
        <Route exact path="/child-details" component={JourneyBlocked} />
        <Route exact path="/result-page" component={JourneyBlocked} />
        <Route exact path="/miscall-error" component={JourneyBlocked} />
        <Route exact path="/redirecting-page" component={JourneyBlocked} />
      </>
    );
  }
}

export default App;
